module.exports = __webpack_public_path__ + "media/images/badge/conquiztador_secondary-0f002e7b67dc5119a46bed57e5fdc679.png";